import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../assets/img/back_btn.png'
import _imports_1 from '../assets/img/db_btn.png'
import _imports_2 from '../assets/img/bwg_btn.png'
import _imports_3 from '../assets/img/reset_btn.png'
import _imports_4 from '../assets/img/ercode.jpg'


const _hoisted_1 = { class: "page-hall" }
const _hoisted_2 = { class: "top" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1)
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: ""
}, null, -1)
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  alt: ""
}, null, -1)
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_3,
  alt: ""
}, null, -1)
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = { class: "pop-wrapper" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "img" }, [
  /*#__PURE__*/_createElementVNode("img", {
    draggable: "false",
    src: _imports_4,
    alt: ""
  })
], -1)
const _hoisted_13 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Panoramic = _resolveComponent("Panoramic")!
  const _component_Slide = _resolveComponent("Slide")!
  const _component_Guide = _resolveComponent("Guide")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: "back-btn",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.back && _ctx.back(...args)))
      }, _hoisted_4),
      _createElementVNode("div", {
        class: "db-btn",
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.goDB && _ctx.goDB(...args)))
      }, _hoisted_6),
      _createElementVNode("div", {
        class: "bwg-btn",
        onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.gobwg && _ctx.gobwg(...args)))
      }, _hoisted_8),
      _createElementVNode("div", {
        class: "reset-btn",
        onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.reset && _ctx.reset(...args)))
      }, _hoisted_10)
    ]),
    _createVNode(_component_Panoramic, {
      ref: "panoramic",
      onLoad: _ctx.load
    }, null, 8, ["onLoad"]),
    (_ctx.isLoaded)
      ? (_openBlock(), _createBlock(_component_Slide, { key: 0 }))
      : _createCommentVNode("", true),
    (_ctx.isLoaded)
      ? (_openBlock(), _createBlock(_component_Guide, { key: 1 }))
      : _createCommentVNode("", true),
    _withDirectives(_createElementVNode("div", _hoisted_11, [
      _createElementVNode("span", {
        class: "close-btn",
        onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.popShow = false))
      }),
      _hoisted_12,
      _createElementVNode("p", {
        innerHTML: _ctx.isWeiXin ? '扫码进入<br>三苏文化大数据库' : '保存图片<br>在微信中扫码进入<br>三苏文化大数据库'
      }, null, 8, _hoisted_13)
    ], 512), [
      [_vShow, _ctx.popShow]
    ])
  ]))
}